module.exports = {
    STANDARD_ERROR: 'datepicker-standardError',
    LESS_ERROR: 'datepicker-lessError',
    MORE_ERROR: 'datepicker-moreError',
    YEAR_MONTH_DAY: 'YYYY MMMM DD',
    YEAR: 'Y'
};